import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { UserFavoriteGeoLocation } from '@wilson/interfaces';

@Injectable({
  providedIn: 'root',
})
export class UserFavoriteLocationsService {
  protected readonly http = inject(HttpClient);
  protected readonly config = inject<ConfigOptions>(ConfigService);

  protected readonly path = 'user-favorite-locations';

  getFavoriteLocations() {
    return this.http.get<UserFavoriteGeoLocation[]>(
      `${this.config.host}/${this.path}?relations=location`,
    );
  }

  setFavoriteLocationForUser(locationId: string) {
    return this.http.post(`${this.config.host}/${this.path}`, {
      locationId,
    });
  }

  removeFavoriteLocationFromUser(locationId: string) {
    return this.http.delete(`${this.config.host}/${this.path}/${locationId}`);
  }
}
